import * as actions from './actions';
import * as getters from './getters';

import {
  SET_ADVERTS
} from './mutation-types'

// initial state
const initialState = {
  adverts: [],
};

// mutations
const mutations = {
  [SET_ADVERTS](state, adverts) {
    state.adverts = adverts.data;
  }
}

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations,
};
